"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminModeFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var AdminModeFactory = /** @class */ (function (_super) {
    __extends(AdminModeFactory, _super);
    function AdminModeFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    AdminModeFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    AdminModeFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    AdminModeFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    AdminModeFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    AdminModeFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return AdminModeFactory;
}(contracts_1.ContractFactory));
exports.AdminModeFactory = AdminModeFactory;
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'previousOwner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'OwnershipTransferred',
        type: 'event',
    },
    {
        inputs: [],
        name: 'isAdminMode',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'owner',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'renounceAdminMode',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'transferOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
];
var _bytecode = '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';
//# sourceMappingURL=AdminModeFactory.js.map